import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";
import { Logo } from "@/components/Logo";

export const Footer = () => {
  const { t } = useI18n();
  return (
    <footer className="border-t border-border/50 bg-background/80 backdrop-blur mt-20">
      <div className="container py-12">
        <div className="grid md:grid-cols-3 gap-8 items-start">
          <div className="space-y-3">
            <Logo iconSize="w-9 h-9" textSize="text-lg" />

            <p className="text-sm text-muted-foreground max-w-xs">{t("footer.tagline")}</p>
          </div>

          <nav className="flex flex-col gap-2 text-sm">
            <Link to="/privacy" className="text-muted-foreground hover:text-neon-green transition">{t("footer.privacy")}</Link>
            <Link to="/terms" className="text-muted-foreground hover:text-neon-green transition">{t("footer.terms")}</Link>
            <Link to="/cookies" className="text-muted-foreground hover:text-neon-green transition">{t("footer.cookies")}</Link>
          </nav>

          <div className="md:text-right space-y-2">
            <a
              href="https://supremecommerce.eu"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block text-sm font-semibold text-neon-purple hover:text-neon-green transition"
            >
              {t("footer.builtBy")} ↗
            </a>
            <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} PunchInk — {t("footer.rights")}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
